// extracted by mini-css-extract-plugin
export default {"profile-table":"cloneUser_profile-table__5aGQB","dropdown-disabled":"cloneUser_dropdown-disabled__WxcwQ","no-data-cloud-invoice":"cloneUser_no-data-cloud-invoice__jk8rE"};